class CartRecommendations extends HTMLElement {

  constructor() {
    super();
    this.generateRecommendations();
  }

  generateRecommendations() {
    const cartForm = document.getElementById('AjaxCartForm');
    if (!cartForm) return;

    const cartItems = cartForm.querySelectorAll('[data-js-cart-item]');
    if (cartItems.length === 0) return;

    // Ascot + Hart: request a larger pool so we can target the free-shipping gap.
    const limit = Math.max(parseInt(this.dataset.limit, 10) || 4, 10);

    const recsUrl = `${KROWN.settings.routes.product_recommendations_url}?section_id=${this.dataset.section}&product_id=${cartItems[0].dataset.productId}&limit=${limit}`;
    const cartUrl = `${(window.Shopify && Shopify.routes && Shopify.routes.root) || '/'}cart.js`;

    Promise.all([
      fetch(recsUrl).then(r => r.text()),
      fetch(cartUrl, { headers: { Accept: 'application/json' } }).then(r => r.json()).catch(() => null)
    ])
      .then(([text, cart]) => {
        const performed = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('[data-js-cart-recommendations-performed]');

        if (!performed || performed.querySelectorAll('[data-js-product-item]').length === 0) return;

        this.orderByFreeShipGap(performed, cart);

        this.innerHTML = performed.innerHTML;
      })
      .catch(e => console.warn(e));
  }

  // Ascot + Hart: reorder recommendations so the cheapest item that closes the
  // free-shipping gap shows first. Runs on the parsed fragment before the slider
  // initializes, so the slider lands on the ideal item with no post-init reflow.
  orderByFreeShipGap(performed, cart) {
    const FREE_SHIP_THRESHOLD = 10000; // $100 in cents
    if (!cart || typeof cart.total_price !== 'number') return;

    const gap = FREE_SHIP_THRESHOLD - cart.total_price;
    if (gap <= 0) return; // already qualifies — leave default heading + order

    const grid = performed.querySelector('.kt-grid');
    if (!grid) return;

    // Swap the heading to signal intent while there is still a gap to close.
    const heading = performed.querySelector('.kt-cart-recommendations__title span');
    const remaining = '$' + (gap / 100).toFixed(2);
    if (heading) heading.textContent = `Add ${remaining} more for free shipping`;

    const items = Array.from(performed.querySelectorAll('[data-js-product-item]'))
      .map(el => ({ el, price: this.priceOf(el) }));

    // Items priced at/above the gap, cheapest first (smallest push over the line).
    const closers = items.filter(i => i.price >= gap).sort((a, b) => a.price - b.price);
    // The rest (too cheap to close it alone), most expensive first (gets closest).
    const rest = items.filter(i => i.price < gap).sort((a, b) => b.price - a.price);

    [...closers, ...rest].forEach(i => grid.appendChild(i.el));
  }

  // Price in cents: prefer the data-price attribute; fall back to the visible
  // price text so it works even when recs are rendered by another theme.
  priceOf(el) {
    const dp = parseInt(el.dataset.price, 10);
    if (dp) return dp;
    const priceEl = el.querySelector('.kt-product-price');
    const match = priceEl && (priceEl.textContent || '').replace(/,/g, '').match(/\d+(?:\.\d+)?/);
    return match ? Math.round(parseFloat(match[0]) * 100) : 0;
  }
}

customElements.define('cart-recommendations', CartRecommendations);